import { Typography } from '@material-ui/core'
import EnphaseLogoWithText from '../../images/enphase_logo_with_text.png'
import { useStyles } from './styles'
const Footer = (props) => {
  const classes = useStyles()
  return (
    <div className={classes.footer}>
      <img
        src={EnphaseLogoWithText}
        className={classes.enphaselogo}
        alt=""
      ></img>
      <Typography className={classes.text}>
        © 2008-2021 Enphase Energy Inc. All rights reserved.{' '}
        <a
          href="https://enphase.com/privacy "
          target="_blank"
          className={classes.anchorlink}
        >
          Privacy
        </a>
        <span className={classes.anchorlink}> | </span>
        <a
          href="https://enphase.com/terms "
          target="_blank"
          className={classes.anchorlink}
        >
          Terms
        </a>
      </Typography>
    </div>
  )
}
export default Footer
